import React from 'react';
import TimeSelectionModal from './TimeSelectionModal';

class ActionButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false
    };
  }

  handleOpenModal = (e) => {
    if (this.props.gameType === 'OUTDOOR' && this.props.title === 'Записаться') {
      this.setState({ showModal: false });
      this.props.handler(e);
      if (e && e.preventDefault) {
        e.preventDefault();
      }
    } else {
      this.props.handler(e);
    }
  }

  handleCloseModal = () => {
    this.setState({ showModal: false });
  }

  handleConfirm = (selectedTime) => {
    this.props.handler(null, selectedTime);
  }

  render() {
    return (
      <div>
        <p>
          <a onClick={this.handleOpenModal}
             className={ "slots__item-record btn " + this.props.colorStyle }
             role="button">{this.props.title}</a>
        </p>
        <TimeSelectionModal
          show={this.state.showModal}
          onClose={this.handleCloseModal}
          onConfirm={this.handleConfirm}
        />
      </div>
    );
  }
}

export default ActionButton;
